import React from 'react';
import { Pill, StatusDot, type PillTone, type StatusDotTone } from '../components/ui';

/**
 * Status_Pill: states the item's current stage in words, for example
 * "Analysis · 21 of 24 loans" or "Data review". A status dot leads the label;
 * the words carry the meaning, never the colour alone.
 *
 * Requirement: 3.6.
 */
export interface StatusPillProps {
  label: string;
  tone?: PillTone;
  className?: string;
}

const DOT_FOR_TONE: Record<PillTone, StatusDotTone> = {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  neutral: 'idle',
  selected: 'running',
};

export const StatusPill: React.FC<StatusPillProps> = ({
  label,
  tone = 'neutral',
  className = '',
}) => (
  <Pill
    tone={tone}
    icon={<StatusDot tone={DOT_FOR_TONE[tone]} />}
    className={`gap-1.5 whitespace-nowrap rounded-full border border-black/5 px-2.5 py-1 text-[13px] ${className}`.trim()}
  >
    <span data-testid="status-pill-label">{label}</span>
  </Pill>
);

export default StatusPill;
